
import { tokenState, userState } from './../services/auth';
import { apiUrl, axiosPost, errorHandling, post } from './../services/utils';
import { defineComponent } from 'vue'
import Toast from 'primevue/toast';
import BasicSpinner from '@/components/BasicSpinner.vue';

export default defineComponent({
    data() {
        return {
            phone:'',
            hasClicked: false,
            errors: [] as string[]
        };
    },
    methods: {
        forgot() {
            this.errors = [];
            if (this.validateEmail() && this.validatePassword()) {
                let formData = {
                    phone_number:this.phone
                };
                this.hasClicked = true;
                let loginUrl = apiUrl + "auth/password/forgot";
                axiosPost(loginUrl, formData).then((result) => {
                    console.log(result);
                    this.hasClicked = false;
                }).catch((err) => {
                    errorHandling(err)
                    this.hasClicked = false;
                });
            }

        },
        validatePassword(): boolean {
            if (this.phone.length < 9 || this.phone.length > 9) {
                this.errors.push('Phone number should be 9 digits long')
                return false;
            }
            return true;
        },
        validateEmail(): boolean {
            return true;
        }
    },
    components: { BasicSpinner }
})
